<div class="dashboard-wrapper">
    <div class="dashboard-left">
        <prl-dashboard-graph></prl-dashboard-graph>
        <prl-dashboard-messages></prl-dashboard-messages>
    </div>
    <div class="dashboard-right">
        @if (this.showMonthlyCommission) {
            <prl-dashboard-monthly-commission></prl-dashboard-monthly-commission>
        }

        @if (this.topZones.length > 0) {
            <prl-dashboard-top-zones [topZones]="topZones"></prl-dashboard-top-zones>
        }

        @if (this.allowSubaffiliates) {
            <prl-dashboard-refer-friend></prl-dashboard-refer-friend>
        }
    </div>
</div>
